import { render } from "./Avatar.vue?vue&type=template&id=5acbd3e2"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=5acbd3e2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__